import React, { useCallback } from "react";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { VerifyCommandProductsListInterface } from "../../../../../../redux/interfaces/picking.interface";
import { setVerifyCommandProductsList } from "../../../../../../redux/reducer/picking.reducer";
import ProductCardComponent from "./ProductCardComponent";
import { QrCodeObjectInterface } from "../../../../../../helpers/qrCodeFormater";

function VerifyCommandTable({
  verifyCommandProductsList,
  verificationZone,
  qrCodeParams,
  handleFocusProductScannedInput,
}: {
  verifyCommandProductsList: VerifyCommandProductsListInterface[];
  verificationZone: string;
  qrCodeParams: QrCodeObjectInterface | null;
  handleFocusProductScannedInput: () => void;
}) {
  const dispatch = useAppDispatch();

  const handleValidateProduct = useCallback(
    (
      product: VerifyCommandProductsListInterface,
      withScanProductAutoFocus?: boolean,
    ) => {
      dispatch(
        setVerifyCommandProductsList({
          idPozitiePicking: product.idPozitiePicking,
          changes: { isValidate: !product.isValidate },
        }),
      );

      if (withScanProductAutoFocus) {
        handleFocusProductScannedInput();
      }
    },
    [dispatch, handleFocusProductScannedInput],
  );

  const getIsScannedProduct = useCallback(
    (product: VerifyCommandProductsListInterface) => {
      if (qrCodeParams?.isBarCode) {
        return qrCodeParams?.serialNumber === product.sn;
      } else {
        return (
          qrCodeParams?.serialNumber === product.sn &&
          qrCodeParams?.lot === product.lot &&
          qrCodeParams?.expirationDate === product.data_exp
        );
      }
    },
    [
      qrCodeParams?.expirationDate,
      qrCodeParams?.isBarCode,
      qrCodeParams?.lot,
      qrCodeParams?.serialNumber,
    ],
  );

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full min-w-[1050px] border-collapse align-middle [&_th]:px-3 [&_th]:py-3 [&_th]:text-left [&_td]:px-3 [&_td]:py-4">
        <thead>
          <tr className="font-semibold text-muted-dark bg-surface-subtle">
            <th className="rounded-l-control">Valid</th>
            <th>Nume</th>
            <th style={{ width: 50 }}>Cantitate</th>
            <th>Lot</th>
            <th style={{ width: 110 }}>Data expirare</th>
            <th style={{ width: 200 }}>Bax</th>
            <th>Celula</th>
            <th className="w-[180px] rounded-r-control"></th>
          </tr>
        </thead>
        <tbody>
          {verifyCommandProductsList?.map((product) => {
            const isScannedProduct = getIsScannedProduct(product);

            return (
              <ProductCardComponent
                key={product.idPozitiePicking}
                commandCode={verificationZone}
                product={product}
                isScannedProduct={isScannedProduct}
                handleValidateProduct={handleValidateProduct}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default VerifyCommandTable;
